document.addEventListener('DOMContentLoaded', () => {
  initLazyLoading();
});

let active_lazyLoading_Deprecated = false;
let allLazyItems_Deprecated = [];
let allLazyCollections_Deprecated = [];
const imagesLazyLoadStatic = () => {
  const bodyContainer = document.querySelector('body');
  addLazyItems(bodyContainer.querySelectorAll('img:not(.notLazy), .icon, .icon-circle, .flag, .flag-circle'));
};

const imagesLazyLoadDynamic = () => {
  MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

  const DOMobserver = new MutationObserver((mutationList) => {
    for (const { addedNodes } of mutationList) {
      for (const addedNode of addedNodes) {
        if (!('querySelectorAll' in addedNode)) continue;
        addLazyItems(addedNode.querySelectorAll('img:not(.notLazy), .icon, .icon-circle, .flag, .flag-circle'), null);
      }
    }
  });

  DOMobserver.observe(document.body, {
    attributes: true,
    childList: true,
    subtree: true
  });
};

const addLazyItems = (items) => {
  if (items?.length <= 0) return;
  let lazyItems = [];
  for (const item of items) {
    const rect = item.getBoundingClientRect();
    if (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
      getComputedStyle(item).display !== 'none'
    ) {
      removeLazyAttr(item);
      continue;
    }
    const root = item.closest('.swiper-container');
    item.classList.add('lazy-item');
    lazyItems.push({ item, root });
    if (item.tagName != 'IMG') continue;
    const dataSrc = item.getAttribute('data-src');
    if (!dataSrc) item.setAttribute('data-src', item.getAttribute('src'));
    if (item.style.visibility != 'hidden' || dataSrc) {
      item.style.visibility = 'hidden';
      item.setAttribute('data-hidden', 'true');
    }
    item.removeAttribute('src');
  }

  if ('IntersectionObserver' in window) {
    lazyItemLoad(lazyItems);
    return;
  }
  allLazyItems_Deprecated = [...allLazyItems_Deprecated, ...lazyItems.map(({ item }) => item)];
  lazyItemLoad_Deprecated();
};

const removeLazyAttr = (lazyItem) => {
  lazyItem.classList.remove('lazy-item');
  if (lazyItem.tagName != 'IMG') return;
  const dataSrc = lazyItem.getAttribute('data-src');
  if (dataSrc) lazyItem.setAttribute('src', dataSrc);
  lazyItem.removeAttribute('data-src');
  if (lazyItem.getAttribute('data-hidden') == 'true' || dataSrc) {
    lazyItem.style.visibility = null;
    lazyItem.removeAttribute('data-hidden');
  }
};

const lazyItemLoad = (itemList) => {
  const loadRoot = (entries, observer, root, item) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const lazyRoot = entry.target;
      itemObserver(root).observe(item);
      observer.unobserve(lazyRoot);
    }
  };

  const loadItem = (entries, observer) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const lazyItem = entry.target;
      removeLazyAttr(lazyItem);
      observer.unobserve(lazyItem);
    }
  };

  const rootObserver = (root, item) =>
    new IntersectionObserver((entries, observer) => loadRoot(entries, observer, root, item), {
      rootMargin: '150px'
    });

  const itemObserver = (root) =>
    new IntersectionObserver(loadItem, {
      root: root,
      rootMargin: '150px'
    });

  for (const { item, root } of itemList) {
    if (root) {
      rootObserver(root, item).observe(root);
      continue;
    }
    itemObserver(root).observe(item);
  }
};

const lazyItemLoad_Deprecated = () => {
  if (active_lazyLoading_Deprecated === true) return;
  active_lazyLoading_Deprecated = true;
  setTimeout(() => {
    for (const lazyItem of allLazyItems_Deprecated) {
      const rect = lazyItem.getBoundingClientRect();
      if (
        !(
          rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
          getComputedStyle(lazyItem).display !== 'none'
        )
      )
        continue;
      removeLazyAttr(lazyItem);
      allLazyItems_Deprecated = allLazyItems_Deprecated.filter((item) => item !== lazyItem);
    }
    for (const lazyCollection of allLazyCollections_Deprecated) {
      const rect = lazyCollection.getBoundingClientRect();
      if (
        !(
          rect.bottom >= 0 &&
          rect.right >= 0 &&
          rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.left <= (window.innerWidth || document.documentElement.clientWidth) &&
          getComputedStyle(lazyCollection).display !== 'none'
        )
      )
        continue;
      loadCollection(lazyCollection);
      allLazyCollections_Deprecated = allLazyCollections_Deprecated.filter((item) => item !== lazyCollection);
    }
    if (allLazyItems_Deprecated.length === 0 && allLazyCollections_Deprecated.length === 0) {
      document.removeEventListener('scroll', lazyItemLoad_Deprecated);
      window.removeEventListener('resize', lazyItemLoad_Deprecated);
      window.removeEventListener('orientationchange', lazyItemLoad_Deprecated);
    }
    active_lazyLoading_Deprecated = false;
  }, 200);
};

function initLazyLoading() {
  imagesLazyLoadStatic();
  imagesLazyLoadDynamic();
  if ('IntersectionObserver' in window) return;
  lazyItemLoad_Deprecated();
  document.addEventListener('scroll', lazyItemLoad_Deprecated);
  window.addEventListener('resize', lazyItemLoad_Deprecated);
  window.addEventListener('orientationchange', lazyItemLoad_Deprecated);
}

export function addCollection(lazyCollectionList) {
  if ('IntersectionObserver' in window) {
    lazyCollectionLoad(lazyCollectionList);
    return;
  }
  const temporaryList = allLazyCollections_Deprecated;
  allLazyCollections_Deprecated = lazyCollectionList;
  if (allLazyItems_Deprecated.length !== 0 || temporaryList.length !== 0) return;
  document.addEventListener('scroll', lazyItemLoad_Deprecated);
  window.addEventListener('resize', lazyItemLoad_Deprecated);
  window.addEventListener('orientationchange', lazyItemLoad_Deprecated);
}

const lazyCollectionLoad = (lazyCollectionList) => {
  function handleIntersection(entries) {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;
      const lazyCollection = entry.target;
      loadCollection(lazyCollection);
      observer.unobserve(lazyCollection);
    }
  }

  const observer = new IntersectionObserver(handleIntersection);

  for (const lazyCollection of lazyCollectionList) observer.observe(lazyCollection);
};

const loadCollection = async (lazyCollection) => {
  const moduleGames = await import('../games/games'),
    moduleAllGames = await import('../games/get-all-games');
  let gamesCollections = await moduleAllGames.getGamesCollections(),
    allGames = await moduleAllGames.getAllGames();
  moduleGames.getGamesToCarousel(lazyCollection.getAttribute('data-games'), gamesCollections, allGames, lazyCollection);
};
